import { toastService } from '@/services/toastService'

export const setToastComponent = (component) => {
  // Legacy support for App.vue ref
}

export const useToast = () => {
  const success = (message, duration = 3500) => {
    toastService.success(message, duration)
  }

  const error = (message, duration = 4000) => {
    toastService.error(message, duration)
  }

  const warning = (message, duration = 4000) => {
    toastService.warning(message, duration)
  }

  const info = (message, duration = 3500) => {
    toastService.info(message, duration)
  }

  return {
    success,
    error,
    warning,
    info
  }
}
